import React, { Component } from "react";

import { Redirect } from 'react-router-dom';
import { Layout, Row, Col, Typography } from "antd";
import Login from "../../containers/Login";
import Core from "../../Core.js";
import history from "../../history";
import { getSocket, initSocket } from "../../socket";

import "./index.scss";

export default class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
    this.button = React.createRef();
    this.handleLoggedIn = this.handleLoggedIn.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleLoggedIn(data) {
    Core.onLogged();
    this.setState({ data });
    if (Core.data().login && getSocket() == null) {
      initSocket(Core.data().login);
    }
  }

  render() {
    const { match } = this.props;
    const { params } = match;
    const { data } = this.state;
    let main = null;
    if (data) {
      if (
        Core.data().config.private == true &&
        Core.data().config.no_home == false
      ) {
        return <Redirect to="/" />;
      } else {
        return <Redirect to="/player" />;
      }
    }
    return (
      <Layout className="login-page default-bg">
        <main>
          <Row
            className="login-page__row"
            gutter={[24, 24]}
            justify="center"
            align="middle"
          >
            <Col
              xxl={14}
              xl={14}
              lg={14}
              md={24}
              sm={24}
              xs={24}
              className="login-page__row__logo-wrapper"
            >
              <img src="/data/images/logo.png" />
            </Col>
            <Col span={10} className="login-page__row__login-wrapper">
              <Login token={params.token} onLoggedIn={this.handleLoggedIn} />
            </Col>
          </Row>
        </main>
      </Layout>
    );
  }
}
